import React, {Component} from 'react';
import TextField from 'material-ui/TextField';

import {HeadlineH1} from './text/Headlines';
import {RCol, Row} from './Grid';
import {ROLE_ADMIN} from '../constants/userConstants';
import {TopBar, TopBarButton, TopBarLeftCol} from './form/FormElements';
import {mapLabel} from './MetaDatas';
import DeleteModal from './DeleteModal';
import ErrorMessage from '../components/ErrorMessage';
import filterOutNotDefinedValues from '../helpers/filterOutNotDefinedValues';

export default class extends Component {
  constructor(props) {
    super(props);
    let data = {};
    if (props.data) {
      data = props.data;
    }
    this.state = {
      _id: null,
      metaType: '',
      value: '',
      validatedAtStr: null,
      showDeleteModal: false,
      ...filterOutNotDefinedValues(data.meta),
    };
  }

  componentWillReceiveProps = newProps => {
    if (newProps.data.error) {
      const {graphQLErrors} = newProps.data.error || {};
      this.setState({errors: graphQLErrors});
    } else {
      const {meta} = newProps.data || {};
      this.setState({errors: [], ...filterOutNotDefinedValues(meta)});
    }
  };

  _goBackToList = () => this.props.history.replace('/metadatas');

  _renderHeadline = () => {
    if (this._isNew()) {
      return <HeadlineH1>Neue Meta Daten</HeadlineH1>;
    }
    return <HeadlineH1>Meta Daten bearbeiten</HeadlineH1>;
  };

  _isNew = () => !this.props.match.params.id;

  _save = () => {
    const {showDeleteModal, ...state} = filterOutNotDefinedValues(this.state);
    this.props
      .save({...state})
      .then(() => this._goBackToList())
      .catch(error => {
        console.log('there was an error sending the query', error);
      });
  };

  _validate = () =>
    this.props
      .validate({_id: this.state._id})
      .then(() => this._goBackToList())
      .catch(error => {
        console.log('there was an error sending the query', error);
      });
  _delete = () =>
    this.props
      .delete({...this.state})
      .then(() => this._goBackToList())
      .catch(error => {
        this.setState({showDeleteModal: false, errors: [error]});
        console.log('there was an error deleting the window', error);
      });
  _showDeleteModal = () => {
    this.setState({showDeleteModal: true});
  };
  _hideDeleteModal = () => {
    this.setState({showDeleteModal: false});
  };

  render() {
    let {metaType, value, validatedAtStr, _id, errors} = this.state;
    const {user} = this.props;

    console.log(validatedAtStr);
    return (
      <div>
        <TopBar>
          <Row>
            <TopBarLeftCol size={0.3} style={{paddingLeft: 100}}>
              {this._renderHeadline()}
            </TopBarLeftCol>
            <RCol size={0.7}>
              {user.role === ROLE_ADMIN && _id && (
                <TopBarButton primary onClick={this._showDeleteModal} label="löschen" />
              )}
              {user.role === ROLE_ADMIN && !validatedAtStr && _id && (
                <TopBarButton primary onClick={this._validate} label="Validieren" />
              )}
              <TopBarButton primary onClick={this._save} label="speichern" />
            </RCol>
          </Row>
        </TopBar>
        <ErrorMessage errors={errors} />
        {this._renderHeadline()}
        <TextField
          type="text"
          fullWidth={true}
          floatingLabelText="Typ*"
          value={mapLabel(metaType)}
          disabled={true}
          onChange={({target: {value}}) => this.setState({metaType: metaType})}
        />
        <TextField
          type="text"
          fullWidth={true}
          floatingLabelText="Wert*"
          value={value}
          onChange={({target: {value}}) => this.setState({value: value})}
        />
        <DeleteModal open={this.state.showDeleteModal} onCancel={this._hideDeleteModal} onConfirm={this._delete} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MetaDataForm.js